import type { ReactNode } from 'react';

import { TourReplayButton } from '../onboarding/TourReplayButton.js';

/**
 * En-tête de page **unifié** : un seul rendu pour le titre et la description de toutes les pages
 * (Overview, Data, Model, Deploy…). Avant, chaque page stylait son titre à la main — d'où des
 * tailles et couleurs qui flottaient. Ici, un titre (`text-primary`) et une description
 * (`text-secondary`, largeur de lecture bornée) partagés, calés sur l'échelle typographique Carbon.
 */
export function PageHeader({
  title,
  lead,
  tourScope,
  children,
}: {
  title: string;
  /** Phrase de description sous le titre (optionnelle). */
  lead?: string;
  /** Portée de visite guidée : affiche un bouton « revoir la visite » (ADR-0031). Optionnel. */
  tourScope?: string;
  /** Contenu additionnel aligné dans l'en-tête (actions, badges…). */
  children?: ReactNode;
}) {
  return (
    <header className="ddp-page-header">
      <div className="ddp-page-header__heading">
        <h1 className="ddp-page-header__title">{title}</h1>
        {/* Description **en ligne**, à droite du titre, séparée par un tiret (posé en CSS) et en
            plus petit : en-tête compact qui rend la page à la lecture. Passe sous le titre si la
            largeur manque (flex-wrap). */}
        {lead && <p className="ddp-page-header__lead">{lead}</p>}
      </div>
      {tourScope && <TourReplayButton scope={tourScope} />}
      {children}
    </header>
  );
}
